import { http } from '../../../../api/http';
import type { DescuentoJudicial } from '../types/descuentoJudicial';

const ENDPOINT = '/planilla/descuentos-judiciales';

export class DescuentoJudicialService {
  static async getAll(idTrabajador?: number, estado?: string): Promise<DescuentoJudicial[]> {
    const params: Record<string, string | number> = {};
    if (idTrabajador) params.idTrabajador = idTrabajador;
    if (estado) params.estado = estado;
    const response = await http.get(ENDPOINT, { params });
    return response.data;
  }

  static async getById(id: number): Promise<DescuentoJudicial> {
    const response = await http.get(`${ENDPOINT}/${id}`);
    return response.data;
  }

  static async create(descuento: Partial<DescuentoJudicial>): Promise<DescuentoJudicial> {
    const response = await http.post(ENDPOINT, descuento);
    return response.data;
  }

  static async update(descuento: Partial<DescuentoJudicial>): Promise<DescuentoJudicial> {
    const response = await http.put(ENDPOINT, descuento);
    return response.data;
  }

  static async desactivar(id: number): Promise<void> {
    await http.put(`${ENDPOINT}/${id}/desactivar`);
  }
}
